/* eslint-disable react/react-in-jsx-scope */
import { WidgetInstance } from 'friendly-challenge';
import React, { useEffect, useRef } from 'react';

const FriendlyCaptcha = ({ siteKey, setCaptchaReady }: { siteKey: string; setCaptchaReady: (isValid: boolean) => void }) => {
    if (!siteKey) {
        console.error('No siteKey provided for FriendlyCaptcha');
        return null;
    }
    const containerRef = useRef<HTMLDivElement | null>(null);
    const widgetRef = useRef<WidgetInstance | null>(null);

    const doneCallback = (solution: any) => {
        setCaptchaReady(true);
    };

    const errorCallback = (err: any) => {
        console.error(err);
        setCaptchaReady(false);
    };

    useEffect(() => {
        if (!widgetRef.current && containerRef.current) {
            widgetRef.current = new WidgetInstance(containerRef.current, {
                startMode: 'auto',
                doneCallback: doneCallback,
                errorCallback: errorCallback,
                sitekey: siteKey // Ensure sitekey is passed to the widget
            });
        }

        return () => {
            if (widgetRef.current !== null && widgetRef.current !== undefined) {
                widgetRef.current.reset();
            }
        };
    }, [siteKey]); // Ensure the effect runs if siteKey changes

    return <div ref={containerRef} className='frc-captcha ms-captcha' />;
};

export default FriendlyCaptcha;
